// Comprehensive Mock Data for Superadmin Features

// Organizations Management Data
export const ORGANIZATIONS_DATA = [
  {
    id: 'org_001',
    name: 'ABC School Group',
    email: 'admin@abcschool.edu',
    phone: '+1-555-0123',
    address: '123 Education Street, Learning City, LC 12345',
    website: 'https://abcschool.edu',
    status: 'active',
    subscription: 'Premium',
    branches: 8,
    students: 12547,
    teachers: 847,
    revenue: 2400000,
    joinDate: '2020-01-15',
    expiryDate: '2025-06-30',
    features: 18,
    storage: 85.2, // GB used
    lastLogin: '2024-03-12T14:30:00Z',
    supportTickets: 3,
    billingStatus: 'paid',
    nextBillingDate: '2024-04-15',
    contact: {
      name: 'Dr. Sarah Johnson',
      title: 'Director',
      phone: '+1-555-0124',
      email: 'sarah.johnson@abcschool.edu'
    }
  },
  {
    id: 'org_002',
    name: 'XYZ Education Network',
    email: 'contact@xyzedu.com',
    phone: '+1-555-0125',
    address: '456 Knowledge Avenue, Study Town, ST 67890',
    website: 'https://xyzedu.com',
    status: 'active',
    subscription: 'Standard',
    branches: 5,
    students: 8932,
    teachers: 542,
    revenue: 1200000,
    joinDate: '2021-03-20',
    expiryDate: '2025-03-31',
    features: 12,
    storage: 52.7,
    lastLogin: '2024-03-11T09:15:00Z',
    supportTickets: 1,
    billingStatus: 'paid',
    nextBillingDate: '2024-04-20',
    contact: {
      name: 'Mr. Robert Chen',
      title: 'CEO',
      phone: '+1-555-0126',
      email: 'robert.chen@xyzedu.com'
    }
  },
  {
    id: 'org_003',
    name: 'Learning Hub International',
    email: 'info@learninghub.org',
    phone: '+1-555-0127',
    address: '789 Academic Blvd, Education City, EC 13579',
    website: 'https://learninghub.org',
    status: 'trial',
    subscription: 'Basic',
    branches: 2,
    students: 1245,
    teachers: 89,
    revenue: 45000,
    joinDate: '2024-02-01',
    expiryDate: '2024-04-01',
    features: 7,
    storage: 12.4,
    lastLogin: '2024-03-12T16:45:00Z',
    supportTickets: 5,
    billingStatus: 'trial',
    nextBillingDate: '2024-04-01',
    contact: {
      name: 'Ms. Maria Rodriguez',
      title: 'Principal',
      phone: '+1-555-0128',
      email: 'maria.rodriguez@learninghub.org'
    }
  },
  {
    id: 'org_004',
    name: 'Future Academy',
    email: 'admin@futureacademy.edu',
    phone: '+1-555-0129',
    address: '321 Innovation Drive, Tech Valley, TV 24680',
    website: 'https://futureacademy.edu',
    status: 'suspended',
    subscription: 'Premium',
    branches: 12,
    students: 15678,
    teachers: 1205,
    revenue: 0, // Suspended
    joinDate: '2019-08-10',
    expiryDate: '2024-08-10',
    features: 0, // Suspended
    storage: 145.8,
    lastLogin: '2024-02-28T11:20:00Z',
    supportTickets: 12,
    billingStatus: 'overdue',
    nextBillingDate: '2024-02-15', // Overdue
    contact: {
      name: 'Dr. James Wilson',
      title: 'Dean',
      phone: '+1-555-0130',
      email: 'james.wilson@futureacademy.edu'
    }
  },
  {
    id: 'org_001',
    name: 'ABC School Group',
    email: 'admin@abcschool.edu',
    phone: '+1-555-0123',
    address: '123 Education Street, Learning City, LC 12345',
    website: 'https://abcschool.edu',
    status: 'active',
    subscription: 'Premium',
    branches: 8,
    students: 12547,
    teachers: 847,
    revenue: 2400000,
    joinDate: '2020-01-15',
    expiryDate: '2025-06-30',
    features: 18,
    storage: 85.2, // GB used
    lastLogin: '2024-03-12T14:30:00Z',
    supportTickets: 3,
    billingStatus: 'paid',
    nextBillingDate: '2024-04-15',
    contact: {
      name: 'Dr. Sarah Johnson',
      title: 'Director',
      phone: '+1-555-0124',
      email: 'sarah.johnson@abcschool.edu'
    }
  },
  {
    id: 'org_002',
    name: 'XYZ Education Network',
    email: 'contact@xyzedu.com',
    phone: '+1-555-0125',
    address: '456 Knowledge Avenue, Study Town, ST 67890',
    website: 'https://xyzedu.com',
    status: 'active',
    subscription: 'Standard',
    branches: 5,
    students: 8932,
    teachers: 542,
    revenue: 1200000,
    joinDate: '2021-03-20',
    expiryDate: '2025-03-31',
    features: 12,
    storage: 52.7,
    lastLogin: '2024-03-11T09:15:00Z',
    supportTickets: 1,
    billingStatus: 'paid',
    nextBillingDate: '2024-04-20',
    contact: {
      name: 'Mr. Robert Chen',
      title: 'CEO',
      phone: '+1-555-0126',
      email: 'robert.chen@xyzedu.com'
    }
  },
  {
    id: 'org_003',
    name: 'Learning Hub International',
    email: 'info@learninghub.org',
    phone: '+1-555-0127',
    address: '789 Academic Blvd, Education City, EC 13579',
    website: 'https://learninghub.org',
    status: 'trial',
    subscription: 'Basic',
    branches: 2,
    students: 1245,
    teachers: 89,
    revenue: 45000,
    joinDate: '2024-02-01',
    expiryDate: '2024-04-01',
    features: 7,
    storage: 12.4,
    lastLogin: '2024-03-12T16:45:00Z',
    supportTickets: 5,
    billingStatus: 'trial',
    nextBillingDate: '2024-04-01',
    contact: {
      name: 'Ms. Maria Rodriguez',
      title: 'Principal',
      phone: '+1-555-0128',
      email: 'maria.rodriguez@learninghub.org'
    }
  },
  {
    id: 'org_004',
    name: 'Future Academy',
    email: 'admin@futureacademy.edu',
    phone: '+1-555-0129',
    address: '321 Innovation Drive, Tech Valley, TV 24680',
    website: 'https://futureacademy.edu',
    status: 'suspended',
    subscription: 'Premium',
    branches: 12,
    students: 15678,
    teachers: 1205,
    revenue: 0, // Suspended
    joinDate: '2019-08-10',
    expiryDate: '2024-08-10',
    features: 0, // Suspended
    storage: 145.8,
    lastLogin: '2024-02-28T11:20:00Z',
    supportTickets: 12,
    billingStatus: 'overdue',
    nextBillingDate: '2024-02-15', // Overdue
    contact: {
      name: 'Dr. James Wilson',
      title: 'Dean',
      phone: '+1-555-0130',
      email: 'james.wilson@futureacademy.edu'
    }
  },
  {
    id: 'org_001',
    name: 'ABC School Group',
    email: 'admin@abcschool.edu',
    phone: '+1-555-0123',
    address: '123 Education Street, Learning City, LC 12345',
    website: 'https://abcschool.edu',
    status: 'active',
    subscription: 'Premium',
    branches: 8,
    students: 12547,
    teachers: 847,
    revenue: 2400000,
    joinDate: '2020-01-15',
    expiryDate: '2025-06-30',
    features: 18,
    storage: 85.2, // GB used
    lastLogin: '2024-03-12T14:30:00Z',
    supportTickets: 3,
    billingStatus: 'paid',
    nextBillingDate: '2024-04-15',
    contact: {
      name: 'Dr. Sarah Johnson',
      title: 'Director',
      phone: '+1-555-0124',
      email: 'sarah.johnson@abcschool.edu'
    }
  },
  {
    id: 'org_002',
    name: 'XYZ Education Network',
    email: 'contact@xyzedu.com',
    phone: '+1-555-0125',
    address: '456 Knowledge Avenue, Study Town, ST 67890',
    website: 'https://xyzedu.com',
    status: 'active',
    subscription: 'Standard',
    branches: 5,
    students: 8932,
    teachers: 542,
    revenue: 1200000,
    joinDate: '2021-03-20',
    expiryDate: '2025-03-31',
    features: 12,
    storage: 52.7,
    lastLogin: '2024-03-11T09:15:00Z',
    supportTickets: 1,
    billingStatus: 'paid',
    nextBillingDate: '2024-04-20',
    contact: {
      name: 'Mr. Robert Chen',
      title: 'CEO',
      phone: '+1-555-0126',
      email: 'robert.chen@xyzedu.com'
    }
  },
  {
    id: 'org_003',
    name: 'Learning Hub International',
    email: 'info@learninghub.org',
    phone: '+1-555-0127',
    address: '789 Academic Blvd, Education City, EC 13579',
    website: 'https://learninghub.org',
    status: 'trial',
    subscription: 'Basic',
    branches: 2,
    students: 1245,
    teachers: 89,
    revenue: 45000,
    joinDate: '2024-02-01',
    expiryDate: '2024-04-01',
    features: 7,
    storage: 12.4,
    lastLogin: '2024-03-12T16:45:00Z',
    supportTickets: 5,
    billingStatus: 'trial',
    nextBillingDate: '2024-04-01',
    contact: {
      name: 'Ms. Maria Rodriguez',
      title: 'Principal',
      phone: '+1-555-0128',
      email: 'maria.rodriguez@learninghub.org'
    }
  },
  {
    id: 'org_004',
    name: 'Future Academy',
    email: 'admin@futureacademy.edu',
    phone: '+1-555-0129',
    address: '321 Innovation Drive, Tech Valley, TV 24680',
    website: 'https://futureacademy.edu',
    status: 'suspended',
    subscription: 'Premium',
    branches: 12,
    students: 15678,
    teachers: 1205,
    revenue: 0, // Suspended
    joinDate: '2019-08-10',
    expiryDate: '2024-08-10',
    features: 0, // Suspended
    storage: 145.8,
    lastLogin: '2024-02-28T11:20:00Z',
    supportTickets: 12,
    billingStatus: 'overdue',
    nextBillingDate: '2024-02-15', // Overdue
    contact: {
      name: 'Dr. James Wilson',
      title: 'Dean',
      phone: '+1-555-0130',
      email: 'james.wilson@futureacademy.edu'
    }
  }
];

// System Users Management Data
export const SYSTEM_USERS_DATA = [
  {
    id: 'user_001',
    name: 'System Administrator',
    email: 'superadmin@studenterp.com',
    role: 'superadmin',
    status: 'active',
    lastLogin: '2024-03-12T14:30:00Z',
    createdDate: '2023-01-01',
    permissions: ['all'],
    organizationAccess: 'all',
    loginCount: 1247,
    avatar: null
  },
  {
    id: 'user_002',
    name: 'Dr. Sarah Johnson',
    email: 'sarah.johnson@abcschool.edu',
    role: 'organization_head',
    status: 'active',
    lastLogin: '2024-03-12T13:15:00Z',
    createdDate: '2020-01-15',
    permissions: ['org_management'],
    organizationAccess: ['org_001'],
    loginCount: 892,
    organization: 'ABC School Group',
    avatar: null
  },
  {
    id: 'user_003',
    name: 'Mr. Robert Chen',
    email: 'robert.chen@xyzedu.com',
    role: 'organization_head',
    status: 'active',
    lastLogin: '2024-03-11T09:15:00Z',
    createdDate: '2021-03-20',
    permissions: ['org_management'],
    organizationAccess: ['org_002'],
    loginCount: 654,
    organization: 'XYZ Education Network',
    avatar: null
  },
  {
    id: 'user_004',
    name: 'Support Agent Alpha',
    email: 'support1@studenterp.com',
    role: 'support_agent',
    status: 'active',
    lastLogin: '2024-03-12T16:00:00Z',
    createdDate: '2023-06-15',
    permissions: ['support_management'],
    organizationAccess: 'all',
    loginCount: 456,
    avatar: null
  }
];

// Billing and Subscription Data
export const BILLING_DATA = [
  {
    id: 'bill_001',
    organizationId: 'org_001',
    organizationName: 'ABC School Group',
    invoiceNumber: 'INV-2024-001',
    amount: 2400,
    status: 'paid',
    dueDate: '2024-04-15',
    paidDate: '2024-03-10',
    billingPeriod: 'March 2024',
    subscription: 'Premium',
    features: 18,
    users: 847,
    storage: 85.2,
    paymentMethod: 'Bank Transfer'
  },
  {
    id: 'bill_002',
    organizationId: 'org_002',
    organizationName: 'XYZ Education Network',
    invoiceNumber: 'INV-2024-002',
    amount: 1200,
    status: 'pending',
    dueDate: '2024-04-20',
    paidDate: null,
    billingPeriod: 'March 2024',
    subscription: 'Standard',
    features: 12,
    users: 542,
    storage: 52.7,
    paymentMethod: 'Credit Card'
  },
  {
    id: 'bill_003',
    organizationId: 'org_004',
    organizationName: 'Future Academy',
    invoiceNumber: 'INV-2024-003',
    amount: 3200,
    status: 'overdue',
    dueDate: '2024-02-15',
    paidDate: null,
    billingPeriod: 'February 2024',
    subscription: 'Premium',
    features: 0, // Suspended
    users: 1205,
    storage: 145.8,
    paymentMethod: 'Bank Transfer'
  }
];

// System Monitoring Data
export const MONITORING_DATA = {
  systemHealth: {
    uptime: 99.97,
    cpuUsage: 45.2,
    memoryUsage: 67.8,
    diskUsage: 32.1,
    networkTraffic: 1234.5, // MB/s
    activeConnections: 15847,
    errorRate: 0.02,
    responseTime: 145 // ms
  },
  
  serverMetrics: [
    {
      id: 'server_001',
      name: 'App Server 1',
      status: 'healthy',
      cpu: 42.1,
      memory: 78.5,
      disk: 34.2,
      uptime: 99.98,
      location: 'US-East',
      lastRestart: '2024-02-15T03:00:00Z'
    },
    {
      id: 'server_002',
      name: 'App Server 2',
      status: 'healthy',
      cpu: 38.7,
      memory: 65.3,
      disk: 29.8,
      uptime: 99.95,
      location: 'US-West',
      lastRestart: '2024-02-20T03:00:00Z'
    },
    {
      id: 'server_003',
      name: 'Database Server',
      status: 'warning',
      cpu: 67.4,
      memory: 89.2,
      disk: 45.6,
      uptime: 99.89,
      location: 'US-Central',
      lastRestart: '2024-03-01T03:00:00Z'
    }
  ],
  
  recentAlerts: [
    {
      id: 'alert_001',
      type: 'warning',
      message: 'Database server memory usage above 85%',
      timestamp: '2024-03-12T15:30:00Z',
      resolved: false,
      severity: 'medium'
    },
    {
      id: 'alert_002',
      type: 'info',
      message: 'Scheduled maintenance completed successfully',
      timestamp: '2024-03-12T03:00:00Z',
      resolved: true,
      severity: 'low'
    },
    {
      id: 'alert_003',
      type: 'error',
      message: 'Failed login attempts exceeded threshold',
      timestamp: '2024-03-11T22:15:00Z',
      resolved: true,
      severity: 'high'
    }
  ]
};

// Support Tickets Data
export const SUPPORT_TICKETS_DATA = [
  {
    id: 'ticket_001',
    title: 'Unable to access student records',
    description: 'Teachers are unable to view student academic records in the system.',
    organizationId: 'org_001',
    organizationName: 'ABC School Group',
    submittedBy: 'john.teacher@abcschool.edu',
    submittedByName: 'John Teacher',
    status: 'open',
    priority: 'high',
    category: 'technical',
    assignedTo: 'Support Agent Alpha',
    createdDate: '2024-03-12T10:30:00Z',
    updatedDate: '2024-03-12T14:15:00Z',
    responses: 3
  },
  {
    id: 'ticket_002',
    title: 'Feature request: SMS notifications',
    description: 'Request to enable SMS notification feature for parent communication.',
    organizationId: 'org_002',
    organizationName: 'XYZ Education Network',
    submittedBy: 'admin@xyzedu.com',
    submittedByName: 'Admin User',
    status: 'in_progress',
    priority: 'medium',
    category: 'feature_request',
    assignedTo: 'Support Agent Beta',
    createdDate: '2024-03-10T14:20:00Z',
    updatedDate: '2024-03-11T16:30:00Z',
    responses: 5
  },
  {
    id: 'ticket_003',
    title: 'Billing inquiry - overdue notice',
    description: 'Received overdue notice but payment was made on time. Please investigate.',
    organizationId: 'org_004',
    organizationName: 'Future Academy',
    submittedBy: 'billing@futureacademy.edu',
    submittedByName: 'Billing Department',
    status: 'resolved',
    priority: 'high',
    category: 'billing',
    assignedTo: 'Support Agent Alpha',
    createdDate: '2024-03-08T09:15:00Z',
    updatedDate: '2024-03-09T11:45:00Z',
    responses: 8
  }
];

// Platform Analytics Data
export const ANALYTICS_DATA = {
  overview: {
    totalRevenue: 5800000,
    monthlyGrowth: 15.2,
    newOrganizations: 12,
    activeUsers: 24567,
    systemUsage: 78.4,
    supportSatisfaction: 4.6
  },
  
  usageMetrics: [
    { month: 'Sep 2023', organizations: 18, users: 18450, revenue: 4200000 },
    { month: 'Oct 2023', organizations: 19, users: 19200, revenue: 4450000 },
    { month: 'Nov 2023', organizations: 20, users: 20100, revenue: 4780000 },
    { month: 'Dec 2023', organizations: 21, users: 21300, revenue: 5020000 },
    { month: 'Jan 2024', organizations: 22, users: 22500, revenue: 5280000 },
    { month: 'Feb 2024', organizations: 23, users: 23800, revenue: 5540000 },
    { month: 'Mar 2024', organizations: 24, users: 24567, revenue: 5800000 }
  ],
  
  featureUsage: [
    { feature: 'Student Management', usage: 98.5, organizations: 24 },
    { feature: 'Attendance Management', usage: 87.2, organizations: 21 },
    { feature: 'Marks & Grades', usage: 92.1, organizations: 22 },
    { feature: 'Fees Management', usage: 89.7, organizations: 20 },
    { feature: 'Parent Communication', usage: 76.3, organizations: 18 },
    { feature: 'Reports & Analytics', usage: 64.8, organizations: 16 }
  ],
  
  subscriptionBreakdown: [
    { package: 'Basic', count: 8, revenue: 960000, percentage: 33.3 },
    { package: 'Standard', count: 10, revenue: 2400000, percentage: 41.7 },
    { package: 'Premium', count: 6, revenue: 2440000, percentage: 25.0 }
  ]
};

// Mock API Functions
export const getOrganizations = (filters = {}) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let data = [...ORGANIZATIONS_DATA];
      
      if (filters.status) {
        data = data.filter(org => org.status === filters.status);
      }
      
      if (filters.subscription) {
        data = data.filter(org => org.subscription === filters.subscription);
      }
      
      resolve({
        success: true,
        data: data,
        total: data.length
      });
    }, 800);
  });
};

export const getSystemUsers = (filters = {}) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let data = [...SYSTEM_USERS_DATA];
      
      if (filters.role) {
        data = data.filter(user => user.role === filters.role);
      }
      
      if (filters.status) {
        data = data.filter(user => user.status === filters.status);
      }
      
      resolve({
        success: true,
        data: data,
        total: data.length
      });
    }, 600);
  });
};

export const getBillingData = (filters = {}) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let data = [...BILLING_DATA];
      
      if (filters.status) {
        data = data.filter(bill => bill.status === filters.status);
      }
      
      resolve({
        success: true,
        data: data,
        total: data.length
      });
    }, 700);
  });
};

export const getMonitoringData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        data: MONITORING_DATA
      });
    }, 500);
  });
};

export const getSupportTickets = (filters = {}) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let data = [...SUPPORT_TICKETS_DATA];
      
      if (filters.status) {
        data = data.filter(ticket => ticket.status === filters.status);
      }
      
      if (filters.priority) {
        data = data.filter(ticket => ticket.priority === filters.priority);
      }
      
      resolve({
        success: true,
        data: data,
        total: data.length
      });
    }, 600);
  });
};

export const getAnalyticsData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        data: ANALYTICS_DATA
      });
    }, 900);
  });
}; 